import React, { useEffect, useState } from "react";
import {
  FlatList,
  Image,
  Modal,
  SafeAreaView,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from "react-native";
import { postJson } from "../../net/http";
import {
  black,
  color_2A2A2A,
  color_333333,
  color_BEBEBE,
  color_EEF2F9,
  color_F1F1F1,
  color_main,
  white,
} from "../../assets/style/colors";
import { showToast } from "../../components/Toast";
import { isValidEmail } from "../login/register";
import { hideLoading, showLoading } from "../../components/Loading";
import {
  Str_Email,
  Str_EmailFormatErr,
  Str_EmailNotNull,
  Str_GroupName,
  Str_GroupNick,
  Str_InputEmail,
  Str_InputGroupName,
  Str_InputNick,
  Str_InputRemarks,
  Str_InputSex,
  Str_Man,
  Str_Nick,
  Str_NotDisclose,
  Str_Remarks,
  Str_SetEmail,
  Str_SetFail,
  Str_SetGroupName,
  Str_SetNick,
  Str_SetRemarks,
  Str_SetSex,
  Str_Sex,
  Str_Woman,
  Str_GroupNameNotNull,
  Str_NickNotNull,
  Str_Cancel,
  Str_Complete,
} from "../../language/string_res";
import { MainNavProps } from "../navigation/main/MainParamList";
import { useIsFocused } from "@react-navigation/native";
import { useStore } from "../../store/UserStore";
import globalEventBus from "../../utils/EventBus";
import { CheckBoxView } from "../../components/CheckBoxView";
import { useChatStore } from "../../store/ChatStore";
import { ImageView } from "../../components/ImageView";
import { ScreenCancelModal, ScreenModal } from "../../components/ScreenModal";

export enum RemarkType {
  USER = "user", // 设置好友备注
  TOPIC = "topic", // 会话备注
  GROUP_NAME = "group_name", //群名称
  GROUP_NICK = "group_nick", //设置自己在群的昵称
  SEX = "sex", //设置自己性别
  EMAIL = "email", //设置自己
  REMARK = "remark", //设置自己昵称
}

export type MineRemarkProps = {
  currentValue?: string;
  type?: RemarkType;
  id: string | number;
};

// 保留原来的组件以保持兼容性
export const MineRemark = ({
  navigation,
  route,
}: MainNavProps<"MineRemark">) => {
  const { type, currentValue, id } = route.params;
  const { state, dispatch } = useStore();
  const { chatState, chatDispatch } = useChatStore();
  const RemarkTypeFields = {
    user: {
      title: Str_Remarks,
      setting_title: Str_SetRemarks,
      setting_placeholder: Str_InputRemarks,
    },
    topic: {
      title: Str_Remarks,
      setting_title: Str_SetRemarks,
      setting_placeholder: Str_InputRemarks,
    },
    group_name: {
      title: Str_GroupName,
      setting_title: Str_SetGroupName,
      setting_placeholder: Str_InputGroupName,
    },
    group_nick: {
      title: Str_GroupNick,
      setting_title: Str_SetNick,
      setting_placeholder: Str_InputNick,
    },
    sex: {
      title: Str_Sex,
      setting_title: Str_SetSex,
      setting_placeholder: Str_InputSex,
    },

    remark: {
      title: Str_Nick,
      setting_title: Str_SetNick,
      setting_placeholder: Str_InputNick,
    },
    email: {
      title: Str_Email,
      setting_title: Str_SetEmail,
      setting_placeholder: Str_InputEmail,
    },
  };

  const sexData = [Str_Man, Str_Woman, Str_NotDisclose];
  const [remark, setRemark] = useState("");

  const dismiss = () => {
    navigation.goBack();
  };
  const handleSave = () => {
    switch (type) {
      case RemarkType.USER:
        handleUserRemark();
        break;
      case RemarkType.TOPIC:
        handleTopicRemark();
        break;
      case RemarkType.GROUP_NAME:
        handleGroupName();
        break;
      case RemarkType.SEX:
        handleUserSex();
        break;
      case RemarkType.EMAIL:
        handleUserEmail();
        break;
      case RemarkType.REMARK:
        handleRemark();
        break;
      case RemarkType.GROUP_NICK:
        handleGroupRemark();
        break;
    }
  };

  async function postUser(body: any) {
    return post(body, "/v1/sdk/user/profile/set");
  }

  async function post(body: any, url: string): Promise<{ code: number }> {
    showLoading();

    const request = await postJson<any>(url, { body });
    hideLoading();
    if (request.code === 0) {
      return { code: 0 };
    } else {
      showToast(request.msg || Str_SetFail);
      return { code: request.code };
    }
  }

  const done = (val: string) => {
    if (state && state.user) {
      let payload = { ...state.user };
      if (type === RemarkType.SEX) {
        payload.sex = val === Str_Woman ? "0" : val === Str_Man ? "1" : "2";
        dispatch({
          type: "UPDATE_USER_INFO",
          payload: payload,
        });
      } else if (type === RemarkType.REMARK) {
        payload.nick = val;
        dispatch({ type: "UPDATE_USER_INFO", payload: payload });
      } else if (type === RemarkType.USER) {
        globalEventBus.emit("Set_Remark_USER", val.trim());
      } else if (type === RemarkType.GROUP_NAME) {
        chatDispatch({ type: "UPDATE_GROUP_NAME", payload: val });
      } else if (type === RemarkType.GROUP_NICK) {
        chatDispatch({ type: "UPDATE_GROUP_REMARK", payload: val });
      } else if (type === RemarkType.TOPIC) {
      }
    }
  };

  const handleGroupRemark = () => {
    const body = { remark: remark.trim(), tid: id };
    post(body, "/v1/sdk/group/member/remark").then((res) => {
      if (res.code === 0) {
        done(remark.trim());
        showToast("设置成功");
        setTimeout(() => dismiss(), 500);
      }
    });
  };

  const handleRemark = () => {
    if (remark.trim().length <= 0) {
      showToast(Str_NickNotNull);
      return;
    }
    const body = { nick: remark.trim() };
    postUser(body).then((res: any) => {
      if (res.code === 0) {
        done(remark.trim());
        showToast("设置成功");
        setTimeout(() => dismiss(), 500);
      }
    });
  };

  const handleUserEmail = () => {
    if (remark.trim().length <= 0) {
      showToast(Str_EmailNotNull);
      return;
    }
    if (!isValidEmail(remark.trim())) {
      showToast(Str_EmailFormatErr);
      return;
    }
    const body = { remail: remark.trim() };
    postUser(body).then((res: any) => {
      if (res.code === 0) {
        done(remark.trim());
        showToast("设置成功");
        setTimeout(() => dismiss(), 500);
      }
    });
  };

  const handleUserSex = () => {
    const sex = remark === Str_Woman ? "0" : remark === Str_Man ? "1" : "2";
    const body = { sex: sex };
    postUser(body).then((res: any) => {
      if (res.code === 0) {
        done(remark.trim());
        showToast("设置成功");
        setTimeout(() => dismiss(), 500);
      }
    });
  };
  // 设置用户备注
  const handleUserRemark = () => {
    const body = { remark: remark.trim(), uid: id };
    post(body, "/v1/sdk/user/remark").then((res: any) => {
      if (res.code === 0) {
        done(remark.trim());
        showToast("设置成功");
        setTimeout(() => dismiss(), 500);
      }
    });
  };

  // 设置会话备注
  const handleTopicRemark = () => {
    const body = { remark: remark.trim(), tid: id };
    post(body, "/v1/sdk/topic/remark").then((res: any) => {
      if (res.code === 0) {
        done(remark.trim());
        showToast("设置成功");
        setTimeout(() => dismiss(), 500);
      }
    });
  };

  // 设置群名称
  const handleGroupName = () => {
    if (remark.trim().length === 0) {
      showToast(Str_GroupNameNotNull);
      return;
    }
    const body = { name: remark.trim(), tid: id };
    post(body, `/v1/sdk/group/profile/set`).then((res: any) => {
      if (res.code === 0) {
        done(remark.trim());
        showToast("设置成功");
        setTimeout(() => dismiss(), 500);
      }
    });
  };

  if (!type) return null;
  const placeholder = RemarkTypeFields[type].setting_title;
  const title = RemarkTypeFields[type].setting_placeholder;
  const tip = RemarkTypeFields[type].title;

  const SettingSex = () => {
    return (
      <View
        style={{
          alignItems: "center",
          marginHorizontal: 12,
          marginTop: 25,
          backgroundColor: "white",
          borderRadius: 5,
        }}
      >
        {/* <Text style={{ fontSize: 23, color: black }}>{Str_SetSex}</Text> */}
        <FlatList
          style={{ width: "100%", paddingHorizontal: 16 }}
          data={sexData}
          renderItem={({ item }) => {
            return (
              <TouchableOpacity
                activeOpacity={1}
                onPress={() => setRemark(item)}
                style={{
                  width: "100%",
                  alignItems: "center",
                  flexDirection: "row",
                }}
              >
                <Text
                  style={{
                    color: color_2A2A2A,
                    fontSize: 17,
                    marginHorizontal: 4,
                    paddingVertical: 16,
                  }}
                >
                  {item}
                </Text>
                <View style={{ flex: 1 }} />
                {remark === item && (
                  <CheckBoxView
                    value={true}
                    style={{ width: 24, height: 24 }}
                  />
                )}
                <View
                  style={{
                    position: "absolute",
                    bottom: 0,
                    width: "100%",
                    height: 0.5,
                    backgroundColor: color_F1F1F1,
                  }}
                />
              </TouchableOpacity>
            );
          }}
        />
      </View>
    );
  };

  const maxLength =
    type === RemarkType.USER ||
    type === RemarkType.TOPIC ||
    type === RemarkType.REMARK ||
    type === RemarkType.GROUP_NICK ||
    type === RemarkType.GROUP_NAME
      ? 20
      : undefined;
  return (
    <ScreenCancelModal
      title={placeholder}
      leftText={Str_Cancel}
      rightText={Str_Complete}
      onLeftPress={dismiss}
      onRightPress={handleSave}
    >
      {type === "sex" ? (
        <View style={{ padding: 24 }}>
          <SettingSex />
        </View>
      ) : (
        <View style={{ padding: 24 }}>
          <View
            style={{
              backgroundColor: "#F8F9FA",
              paddingVertical: 20,
              paddingHorizontal: 20,
              borderRadius: 12,
              borderWidth: 1,
              borderColor: "#E8E8E8",
            }}
          >
            <View
              style={{
                width: "100%",
                flexDirection: "row",
                marginBottom: 12,
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Text style={[styles.tip, { fontSize: 14, color: "#666" }]}>
                {tip}
              </Text>
              {maxLength && maxLength > 0 && (
                <Text
                  style={[
                    styles.tip,
                    {
                      fontSize: 13,
                      color: remark.length === maxLength ? "#FF6B6B" : "#999",
                    },
                  ]}
                >
                  {remark.length}/{maxLength}
                </Text>
              )}
            </View>
            <View
              style={[
                styles.inputBg,
                {
                  marginTop: 0,
                  backgroundColor: white,
                  borderWidth: 1,
                  borderColor: remark.length > 0 ? color_main : "#E0E0E0",
                  shadowColor: "#000",
                  shadowOffset: { width: 0, height: 1 },
                  shadowOpacity: 0.05,
                  shadowRadius: 2,
                  elevation: 1,
                },
              ]}
            >
              <TextInput
                placeholder={placeholder}
                editable={true}
                focusable={true}
                autoFocus={true}
                selectionColor={color_main}
                placeholderTextColor={color_BEBEBE}
                style={[styles.input, { fontSize: 16 }]}
                value={remark}
                maxLength={maxLength}
                returnKeyType={"done"}
                onSubmitEditing={handleSave}
                onChangeText={setRemark}
              />
              {remark.length > 0 && (
                <TouchableOpacity
                  activeOpacity={0.7}
                  onPress={() => {
                    setRemark("");
                  }}
                  style={{
                    height: 40,
                    justifyContent: "center",
                    alignItems: "center",
                    paddingHorizontal: 12,
                  }}
                >
                  <Image
                    source={require("../../assets/image/icon_del.png")}
                    style={{ width: 18, height: 18, opacity: 0.6 }}
                  />
                </TouchableOpacity>
              )}
            </View>
          </View>
        </View>
      )}
    </ScreenCancelModal>
  );
};

const styles = StyleSheet.create({
  inputBg: {
    flexDirection: "row",
    backgroundColor: color_EEF2F9,
    borderRadius: 10,
    alignItems: "center",
    height: 50,
    paddingHorizontal: 16,
    minHeight: 50,
  },
  input: {
    height: 50,
    flex: 1,
    color: color_333333,
    fontSize: 16,
    paddingVertical: 0,
  },
  tip: { fontSize: 15, color: "#AAA9A9" },
});
